
import React from 'react';
import ProfileSidebar from '@/components/profile/ProfileSidebar';
import { User } from '@/contexts/auth/types';
import { NotificationPreferences } from '@/contexts/auth/types';
import { CompanyInfo } from '@/lib/types';

interface ProfileTabProps {
  children: React.ReactNode;
  user: User | null;
  displayName: string;
  email?: string;
  role?: string;
  contactPhone?: string;
  website?: string;
  notificationPreferences?: NotificationPreferences;
  companyName?: string;
  companyInfo?: CompanyInfo;
  hideSidebar?: boolean;
}

const ProfileTab: React.FC<ProfileTabProps> = ({
  children,
  user,
  displayName,
  email,
  role,
  contactPhone,
  website,
  notificationPreferences,
  companyName,
  companyInfo,
  hideSidebar = false
}) => {
  // If sidebar is hidden, just return the children
  if (hideSidebar) {
    return <div className="w-full">{children}</div>;
  }

  return (
    <div className="">
      <div className="">
        {children}
      </div>
    </div>
  );
};

export default ProfileTab;
